import { Component } from '@angular/core';
import {TranslocoService} from "@ngneat/transloco";
import {AbstractComponent} from "@components";
import {
  LEAGUES_MANAGEMENT_COMPETITORS,
  LEAGUES_MANAGEMENT_EVENTS,
  LEAGUES_MANAGEMENT_RESULTS
} from "../../../../../app-routing.module";

@Component({
  selector: 'app-league-management',
  templateUrl: './league-management.component.html',
  styleUrl: './league-management.component.scss',
  standalone: false
})
export class LeagueManagementComponent extends AbstractComponent{
  readonly LEAGUES_MANAGEMENT_EVENTS = LEAGUES_MANAGEMENT_EVENTS;
  readonly LEAGUES_MANAGEMENT_COMPETITORS = LEAGUES_MANAGEMENT_COMPETITORS;
  readonly LEAGUES_MANAGEMENT_RESULTS = LEAGUES_MANAGEMENT_RESULTS;


  constructor(
      public translocoService: TranslocoService,
  ) {
    super();
  }

  ngOnInit() {
  }

}
